import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Popover, Card, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Parameters from 'shared/parameters';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { CurrencyFormatter, GetOrderTag } from 'shared/services/Utility';
import deFlag from '../../../src/img/de-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';

interface Props {
    location: any;
}

const { Title, Text } = Typography;
const { confirm } = Modal;
const { Option } = Select;
export default function LearnersReport(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [selectedOrg, setSelectedOrg] = useState(null as any);
    const [pagination, setPagination] = useState({ page: 1, per_page: '50' } as any);
    const [total, setTotal] = useState(0);
    const [items, setItems] = useState([] as any[]);
    const [organizations, setOrganizations] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const columns = [
        {
            title: t('genDict.name'),
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: t('genDict.email'),
            key: 'email',
            dataIndex: 'email',
        },
        {
            title: t('genDict.coursesPurchased'),
            key: 'coursesPurchased',
            dataIndex: 'courses_purchased_count',
        },
        {
            title: t('genDict.coursesCompleted'),
            key: 'coursesCompleted',
            dataIndex: 'courses_completed_count',
        },
        {
            title: t('genDict.quizCompleted'),
            key: 'quizCompleted',
            render: (a: any)=><Text>{a.quizes_completed_count} / {a.average_marks_in_quiz}</Text>
        },
        {
            title: t('genDict.packagePurchaseCount'),
            key: 'packagePurchaseCount',
            dataIndex: 'packages_purchased_count',
        }
    ];
    const refreshItems = () => {
        setFetching(true);
        API_SERVICE.fetchReports({
            ...pagination,
            filter_organization_id: selectedOrg,
            order: 'DESC',
            order_by: 'id',
        }, 'learners').then(({
                               data: {
                                   data: {
                                       count,
                                       current_page,
                                       items,
                                       per_page,
                                       total,
                                   },
                               },
                           }) => {
            setItems(items);
            setTotal(total);
        }).catch(e => {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }).finally(() => {
            setFetching(false);

        });
    };
    const fetchOrganizations = async () => {
        try {
            const {
                data: {
                    data: {
                        items: o,
                    },
                },
            } = await API_SERVICE.fetchOrganizations({ per_page: 1000, order_by: 'id', page: 1, order: 'DESC' });
            setOrganizations(o);
            if (o.length) {
                setSelectedOrg(o[0].id);
            }
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {

        }
    };
    useEffect(() => {
        if (Parameters.Mode === 'SUPER_ADMIN') {
            fetchOrganizations();
        } else {
            refreshItems();
        }
    }, []);
    useEffect(() => {
        if (selectedOrg) {
            refreshItems();
        }
    }, [selectedOrg, pagination, props.location]);
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={'list-page-wrapper'}>
                    <div className="container-fluid">
                        <div className='row mb-3'>
                            <div className='col-md-12 p-0 d-flex align-items-center'>
                                <div className='mr-4'>
                                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                </div>
                                <div><h3 className='mb-0'>{t('genDict.learnersReport')}</h3></div>
                            </div>
                            <div className='ml-auto'>
                                {
                                    Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                        setSelectedOrg(e);
                                        setPagination({ ...pagination, page: 1, total: 0 });
                                    }
                                    }>
                                        {
                                            organizations.map((o: any) => {
                                                return <Option value={o.id}>{o.name}</Option>;
                                            })
                                        }
                                    </Select>
                                }
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 p-0'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                    <div className="col-md-12 pb-3">
                                        <div className="table-responsive table-br-5 box-shadow mt-2">
                                            <table className="table  table-meetings table-report">
                                            <thead>
                                                <tr>
                                                <th className="text-uppercase text-secondary">{t('genDict.StudentName')}</th>
                                                <th className="text-uppercase text-secondary">{t('genDict.email')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.NoOfCourse')}</th>
                                                {/* <th className="text-uppercase text-secondary">Purchased course</th> */}
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.CompletedCourses')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.quizCompleted')}</th>
                                                {/* <th className="text-uppercase text-secondary text-center">No. of package purchased</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    items && items.map(item =>{
                                                        console.log(item);
                                                        return <tr>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    {/* <div className="mr-3">
                                                                        <img src={deFlag} className="uploaded-img-cat" height="40" width="40"/>
                                                                    </div> */}
                                                                    <div className="">
                                                                        <p className="mb-0"><span>{item.name}</span></p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="text-secondary">{item.email}</td>
                                                            <td className="text-secondary text-center">{item.courses_purchased_count}</td>
                                                            {/* <td className="text-secondary">{item.courses_purchased_count}</td> */}
                                                            <td className="text-secondary text-center">{item.courses_completed_count}</td>
                                                            <td className="text-secondary text-center">{item.quizes_completed_count}{/*/{Math.round(item.average_marks_in_quiz)} */}</td>
                                                            {/* <td className="text-secondary text-center">{item.packages_purchased_count}</td> */}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    {/* <Row gutter={20} justify={'space-between'}>
                        <Col flex={'auto'}>
                            <Title level={3}>{t('genDict.learnersReport')}</Title>
                        </Col>
                        <Col>
                            {
                                Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                    setSelectedOrg(e);
                                    setPagination({ ...pagination, page: 1, total: 0 });
                                }
                                }>
                                    {
                                        organizations.map((o: any) => {
                                            return <Option value={o.id}>{o.name}</Option>;
                                        })
                                    }
                                </Select>
                            }
                        </Col>
                    </Row>
                    <Table loading={fetching} scroll={{ x: true }} pagination={{
                        onChange: (page, per_page) => {
                            setPagination({ ...pagination, page: page, per_page: per_page || pagination.per_page });
                        },
                        pageSize: pagination.per_page,
                        hideOnSinglePage: true,
                        total: total,
                    }} dataSource={items} columns={columns}/> */}
                </div>
                )
            }
        </AuthConsumer>
    );
}
